var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_116087",
    "data-name": "Group 116087",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120.033,
    viewBox: "0 0 120 120.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 120,
    height: 120.033,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M120,60A60,60,0,1,1,60,0a59.8,59.8,0,0,1,60,60",
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "image-svgrepo-com",
    d: "M10.2,3H36.244c2.5,0,3.413.261,4.328.75a5.117,5.117,0,0,1,2.123,2.123c.49.915.75,1.822.75,4.328V27.076l-9.866-9.107a3.37,3.37,0,0,0-5.089.607l-7.033,10.55L16.282,25.8a3.37,3.37,0,0,0-4.4.67L3.011,37.042q-.011-.4-.011-.8V10.2c0-2.505.261-3.413.75-4.328A5.117,5.117,0,0,1,5.874,3.75C6.788,3.261,7.7,3,10.2,3ZM31.5,22.167,43.445,33.193v3.049c0,2.5-.261,3.413-.75,4.328a5.105,5.105,0,0,1-2.123,2.123c-.915.49-1.822.75-4.328.75H10.2c-2.505,0-3.413-.261-4.328-.75a5.179,5.179,0,0,1-1.09-.775l9.9-11.8L19.956,33.5a3.37,3.37,0,0,0,4.627-.966L31.5,22.164ZM14.208,9.741a4.37,4.37,0,0,0-4.467,4.467,4.415,4.415,0,0,0,4.467,4.521,4.427,4.427,0,0,0,4.521-4.521A4.384,4.384,0,0,0,14.208,9.741Z",
    transform: "translate(36.776 35.269)",
    fill: "#d1d1d1",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.0accb24584e40802dfe6984b70d8691d.svg";
export { ForwardRef as ReactComponent };